import React, { FC } from 'react';


export const PlaceholderIcon: FC = () => (
    <svg width='360' height='360' viewBox='0 0 360 360' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='180' cy='180' r='180' fill='url(#paint0_linear_2120_16108)' />
        <g filter='url(#filter0_d_2120_16108)'>
            <rect x='16' y='44' width='328' height='80' rx='16' fill='white' />
        </g>
        <circle cx='56' cy='84' r='24' fill='black' fillOpacity='0.04' />
        <rect x='96' y='64' width='96' height='16' rx='8' fill='black' fillOpacity='0.04' />
        <rect x='96' y='88' width='64' height='16' rx='8' fill='black' fillOpacity='0.04' />
        <rect x='249' y='73' width='78' height='22' rx='11' stroke='black' strokeOpacity='0.04' strokeWidth='2' />
        <g filter='url(#filter1_d_2120_16108)'>
            <rect x='16' y='140' width='328' height='80' rx='16' fill='white' />
        </g>
        <circle cx='56' cy='180' r='24' fill='black' fillOpacity='0.04' />
        <rect x='96' y='160' width='96' height='16' rx='8' fill='black' fillOpacity='0.04' />
        <rect x='96' y='184' width='64' height='16' rx='8' fill='black' fillOpacity='0.04' />
        <rect x='249' y='169' width='78' height='22' rx='11' stroke='black' strokeOpacity='0.04' strokeWidth='2' />
        <g filter='url(#filter2_d_2120_16108)'>
            <rect x='16' y='236' width='328' height='80' rx='16' fill='white' />
        </g>
        <circle cx='56' cy='276' r='24' fill='black' fillOpacity='0.04' />
        <rect x='96' y='256' width='96' height='16' rx='8' fill='black' fillOpacity='0.04' />
        <rect x='96' y='280' width='64' height='16' rx='8' fill='black' fillOpacity='0.04' />
        <rect x='249' y='265' width='78' height='22' rx='11' stroke='black' strokeOpacity='0.04' strokeWidth='2' />
        <defs>
            <filter id='filter0_d_2120_16108' x='0' y='32' width='360' height='112' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='4' />
                <feGaussianBlur stdDeviation='8' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2120_16108' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2120_16108' result='shape' />
            </filter>
            <filter id='filter1_d_2120_16108' x='0' y='128' width='360' height='112' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='4' />
                <feGaussianBlur stdDeviation='8' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2120_16108' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2120_16108' result='shape' />
            </filter>
            <filter id='filter2_d_2120_16108' x='0' y='224' width='360' height='112' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='4' />
                <feGaussianBlur stdDeviation='8' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2120_16108' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2120_16108' result='shape' />
            </filter>
            <linearGradient id='paint0_linear_2120_16108' x1='180' y1='0' x2='180' y2='360' gradientUnits='userSpaceOnUse'>
                <stop stopOpacity='0.02' />
                <stop offset='1' stopOpacity='0.04' />
            </linearGradient>
        </defs>
    </svg>
);
